var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/FolderGroupingChild.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FolderGroupingChild = ({
  color = '#4C5ECF',
  ...other
}) => /*#__PURE__*/_jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: [/*#__PURE__*/_jsx("rect", {
    opacity: "0.1",
    width: "24",
    height: "24",
    rx: "4",
    fill: color
  }), /*#__PURE__*/_jsx("path", {
    d: "M10.4425 6.4425C10.1575 6.1575 9.775 6 9.3775 6H5.5C4.675 6 4.0075 6.675 4.0075 7.5L4 16.5C4 17.325 4.675 18 5.5 18H18.5C19.325 18 20 17.325 20 16.5V9C20 8.175 19.325 7.5 18.5 7.5H11.5L10.4425 6.4425Z",
    fill: color
  }), /*#__PURE__*/_jsx("g", {
    opacity: "0.8",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.12 11.7502L12.0001 10.1014L9.87842 11.7516L11.9997 13.4009L14.12 11.7502ZM8.9293 12.2804L8.7005 12.1021C8.472 11.924 8.47214 11.5785 8.7008 11.4007L11.7273 9.04675C11.8878 8.92192 12.1125 8.92192 12.273 9.04675L15.2981 11.3996C15.5272 11.5778 15.5268 11.9241 15.2973 12.1018L15.0668 12.2804L12.273 14.4554C12.2199 14.4967 12.1599 14.5244 12.0974 14.5384C12.0312 14.5533 11.9623 14.5528 11.8962 14.5369C11.8361 14.5225 11.7784 14.4954 11.7272 14.4556L8.9293 12.2804ZM15.179 13.4603C15.0556 13.4272 14.9202 13.4518 14.8145 13.534L12.2688 15.514C12.2629 15.5186 12.2569 15.523 12.2508 15.5273C12.2055 15.559 12.1557 15.5814 12.104 15.5943C12.0352 15.6115 11.9632 15.612 11.8942 15.5959C11.8393 15.583 11.7862 15.5595 11.7383 15.5254C11.7332 15.5217 11.7281 15.5179 11.7231 15.5141L9.17962 13.5365C9.07554 13.4556 8.94242 13.4309 8.82071 13.4626C8.76742 13.4765 8.7163 13.5011 8.67074 13.5365C8.45741 13.7025 8.45741 14.0249 8.67074 14.1908L11.7273 16.5681C11.7359 16.5749 11.7448 16.5812 11.7538 16.5872C11.9038 16.6872 12.1 16.6866 12.2494 16.5853C12.2574 16.5798 12.2653 16.5741 12.273 16.5681L15.327 14.1928C15.5417 14.0258 15.5418 13.7014 15.3272 13.5342C15.2822 13.4991 15.2317 13.4744 15.179 13.4603Z",
      fill: "white"
    })
  })]
});